export const normalizeTransactionName = name => {
  if (typeof name !== 'string') return name
  return name.replace(/\/chat\/[^/?]+/, '/chat/:conversationId')
}
